import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Reuse the same global styles as apps/web.
import '@/styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
